import {IonAvatar, IonBadge, IonButton, IonCol, IonGrid, IonIcon, IonNote, IonRouterLink, IonRow, IonText, useIonAlert, useIonRouter} from "@ionic/react";
import styles_CardDetailFor_7_2 from "./CardDetailFor_7_2.module.scss";
import styles_ContractBonusItem from "./ContractBonusItem.module.scss";
import {bookmark, bookmarkOutline, chatboxEllipses, chatboxEllipsesOutline, heart, heartOutline, star} from "ionicons/icons";
import Ln_TokenPictureSetCoverImg from "../pages/Ln_TokenPictureSetCoverImg";
import {ActionLink} from "./ActionLink";
import styles_Common from "../pages/Common.module.scss";
import moment from "moment";
import QRCode from "react-qr-code";
import {navToPg_7_2_2, navToPg_7_5, promptBrowserToLogin} from "../pages/Utils";
import {Fragment} from "react";
import styles_ContractBonusDetailItem from "./ContractBonusDetailItem.module.scss";
import {push_pg_7_2_1__joinquiz, push_pg_7_3_1_JoinEvent, push_pg_7_3_1_QuitEvent} from "../store/Pg_7_Store";
import {useStoreState} from "pullstate";
import {AuthStore, UserEventTestStore} from "../store/Common_Store";
import {getPageData} from "../store/Selectors";
import useForceRender from "../_/useForceRender";

export const CardDetailFor_7_2_1 = ({
                                      Item_Sdgs課程, 已兌換次數, QrCode, reload,
                                            fromHome = false,
                                            noLink = false,
                                            onClickCapture = null as any
                                        }) => {
    const router = useIonRouter();
    const eventJoins = useStoreState(UserEventTestStore, getPageData);
    const forceRender = useForceRender();

    ///#region 會員
    const authStore = useStoreState(AuthStore, getPageData);
    const hasAuthed = authStore?.signBy ?? false;
    const Item_會員 = hasAuthed ? authStore?.AuthData : undefined;
    ///#endregion

    const [presentAlert] = useIonAlert();

    if (!Item_Sdgs課程) {
        return <>(ERROR:Item_Sdgs課程)</>;
    }

    let _Sdgs分類: any = Item_Sdgs課程?._Sdgs分類;
    if (!_Sdgs分類) {
        return <>(ERROR:_Sdgs分類)</>;
    }

    const _push_pg_7_3_1__quitevent = async () => {
        if (!hasAuthed) {
            promptBrowserToLogin();
            return;
        }

        if (await push_pg_7_3_1_QuitEvent({
            p1: Item_Sdgs課程.Sdgs課程Id,
        })) {
            //navToPg_1_1();
            //reload();
        }
    }

    const _push_pg_7_2_1__joinquiz = async () => {
        if (!hasAuthed) {
            promptBrowserToLogin();
            return;
        }

        if (await push_pg_7_2_1__joinquiz({
            p1: Item_Sdgs課程.Sdgs課程Id,
        })) {
            //navToPg_1_1();
            await reload();

            presentAlert({
                backdropDismiss: false,
                keyboardClose: false,
                header: '歡迎您參與測驗！',
                //subHeader: 'A Sub Header Is Optional',
                message: Item_Sdgs課程.名稱,
                buttons: [
                    {
                        text: '稍後再在測驗',
                        role: 'cancel',
                        handler: () => {
                            //reload();
                        },
                    },
                    {
                        text: '開始測驗',
                        role: 'confirm',
                        handler: () => {
                            navToPg_7_2_2(router, Item_Sdgs課程.Sdgs課程Id);
                        },
                    },
                ]
            })
        }
    }

    const start = async () => {
        // const platforms = getPlatforms();
        // const isWeb = (platforms.includes("desktop") || platforms.includes("mobileweb") || platforms.includes("pwa"));
        //
        // if (!isWeb) {
        //     const data = await BarcodeScanner.scan();
        //     if (data) {
        //         handleSuccess(data);
        //     }
        // } else {
        //     presentWebModal({
        //         presentingElement: pageRef.current
        //     });
        // }
        if (!hasAuthed) {
            promptBrowserToLogin();
            return;
        }

        navToPg_7_2_2(router, 1);
    }

    return (
        <>
            <ActionLink link={`/tabs/7_2_1/${Item_Sdgs課程.Sdgs課程Id}`} className={styles_CardDetailFor_7_2.container} noLink={noLink} onClickCapture={onClickCapture}>
                <div className={styles_CardDetailFor_7_2.postBar}>
                    {Ln_TokenPictureSetCoverImg({
                        圖片組: Item_Sdgs課程.封面組,
                        名稱: 'cover',
                    })}
                </div>

                <div className={styles_CardDetailFor_7_2.containerInner}>


                    <div className={styles_ContractBonusItem.nameBar}>
                        <div className="container">
                            {/*<div className="l">*/}
                            {/*    <IonAvatar className="avatar">*/}
                            {/*        {Ln_TokenPictureSetCoverImg({*/}
                            {/*            圖片組: Item_Token_會員公開.個人照片,*/}
                            {/*            名稱: 'cover',*/}
                            {/*        })}*/}
                            {/*    </IonAvatar>*/}
                            {/*</div>*/}
                            {/*<div className="r">*/}
                            {/*    {Item_Token_會員公開.暱稱}*/}
                            {/*</div>*/}
                            <ActionLink link={`/tabs/7_2?contractId=${_Sdgs分類.Sdgs課程分類Id}`} noLink={false} >
                                <div className="r2">
                                    <div className="roundbg">
                                        {_Sdgs分類.顯示名稱}
                                    </div>
                                </div>
                            </ActionLink>
                        </div>
                    </div>

                    <div className={styles_CardDetailFor_7_2.titleBar}>
                        {Item_Sdgs課程.名稱}
                    </div>

                    <div className={styles_ContractBonusItem.timeRangeBar}>
                        {Item_Sdgs課程.Esg課程分類}
                    </div>


                        <div className={styles_ContractBonusItem.timeRangeBar}>
                            積分: {Item_Sdgs課程.完成可獲得點數 > 0 ? '+' : ''}{Item_Sdgs課程.完成可獲得點數}
                        </div>


                    {eventJoins[Item_Sdgs課程.Sdgs課程Id] && <Fragment>
                        {/*{JoinEventState?.indexOf("已參加活動") >= 0 && <Fragment>*/}
                        {/*    <div className={styles_ContractBonusDetailItem.redeemBar}>*/}
                        {/*        <div className="l">入場時請向工作人員出示QR碼，取得參與活動積分</div>*/}
                        {/*        <div className="c" style={{height: "auto", margin: "0 auto", maxWidth: 125, width: "100%"}}>*/}
                        {/*            <QRCode*/}
                        {/*                size={256}*/}
                        {/*                style={{height: "auto", maxWidth: "100%", width: "100%"}}*/}
                        {/*                value={QrCode}*/}
                        {/*                viewBox={`0 0 256 256`}*/}
                        {/*            />*/}
                        {/*        </div>*/}
                        {/*        <div className="f"></div>*/}
                        {/*    </div>*/}
                        {/*</Fragment>}*/}

                        {eventJoins[Item_Sdgs課程.Sdgs課程Id].已正確完成 !== true ?
                            <IonButton className={styles_CardDetailFor_7_2.buttonCanDo} fill={"solid"} onClick={() => _push_pg_7_2_1__joinquiz()} expand="block">
                                開始測驗
                            </IonButton> : <IonButton disabled={true} className={styles_CardDetailFor_7_2.buttonDid} fill={"solid"} onClick={() => _push_pg_7_3_1__quitevent()} expand="block">
                                已通過測驗
                            </IonButton>}
                    </Fragment>
                    }
                    {!eventJoins[Item_Sdgs課程.Sdgs課程Id] &&
                        <IonButton className={styles_CardDetailFor_7_2.buttonCanDo} fill={"solid"} onClick={() => _push_pg_7_2_1__joinquiz()} expand="block">
                            參加測驗
                        </IonButton>
                    }

                    <div className={styles_CardDetailFor_7_2.contentBar}>
                        {/*<li className="l">介紹</li>*/}
                        <IonText className="c" dangerouslySetInnerHTML={{__html: Item_Sdgs課程.課程內容說明}}/>
                    </div>
                </div>

                {/*<div className={styles_CardDetailFor_7_2.containerInner}>*/}
                {/*    {(QrCode !== null) ? <>*/}
                {/*        {Item_合約獎勵.兌換時間 ? <>*/}
                {/*                <div className={styles_CardDetailFor_7_2.redeemBar}>*/}
                {/*                    <div className="l">已兌換</div>*/}
                {/*                </div>*/}
                {/*            </> :*/}
                {/*            <>*/}
                {/*                <div className={styles_CardDetailFor_7_2.redeemBar}>*/}
                {/*                    <div className="l">掃描 QR code 兌換</div>*/}
                {/*                    <div className="c" style={{height: "auto", margin: "0 auto", maxWidth: 125, width: "100%"}}>*/}
                {/*                        <QRCode*/}
                {/*                            size={256}*/}
                {/*                            style={{height: "auto", maxWidth: "100%", width: "100%"}}*/}
                {/*                            value={QrCode}*/}
                {/*                            viewBox={`0 0 256 256`}*/}
                {/*                        />*/}
                {/*                    </div>*/}
                {/*                    <div className="f"></div>*/}
                {/*                </div>*/}
                {/*            </>*/}
                {/*        }*/}
                {/*    </> : <></>}*/}

                {/*    /!*<ul className={styles_CardDetailFor_7_2.timeRangeBar}>*!/*/}
                {/*    /!*    <li className="l">使用期限</li>*!/*/}
                {/*    /!*    <div className="c">*!/*/}
                {/*    /!*        {moment(Item_合約獎勵.起始生效區間).format('YYYY/MM/DD')} - {moment(Item_合約獎勵.生效區間結束).format('YYYY/MM/DD')}*!/*/}
                {/*    /!*    </div>*!/*/}
                {/*    /!*</ul>*!/*/}

                {/*    <div className={styles_CardDetailFor_7_2.qrBar}>*/}
                {/*        /!*<li className="l">使用狀態</li>*!/*/}
                {/*        <div className="c">*/}
                {/*            每個{Item_合約獎勵._合約.Name}孵化器可兌換{Item_合約獎勵.CanUseTimesPerTokenEnw}次，您共有{總共可兌換次數}次兌換機會（目前您已兌換{已兌換次數}次，尚可兌換{Math.max(0, 總共可兌換次數 - 已兌換次數)}次）。*/}
                {/*            /!*每個數位收藏，可兌換 {Item_合約獎勵.CanUseTimesPerTokenEnw} 次，共有 {總共可兌換次數} 次兌換。已兌換 {已兌換次數} 次，尚可兌換 {總共可兌換次數 - 已兌換次數} 次。*!/*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}
            </ActionLink>
        </>
    );
}
